module.exports = __webpack_public_path__ + "img/kapysta.9d48cdc3.svg";